/* eslint-disable no-unused-vars,no-underscore-dangle,no-param-reassign */
require('../utils/lp_boclips_fetcher');

const { LP, $ } = window;
const LpBoclips = LP.module('LpBoclips');

const LpBoclipsActions = {
  cache: {},

  fetcher() {
    if (
      Object.prototype.hasOwnProperty.call(LpBoclips.LpBoclipsActions.cache, 'fetcher')
    ) {
      return LpBoclips.LpBoclipsActions.cache.fetcher;
    }
    LpBoclips.LpBoclipsActions.cache.fetcher = new LpBoclips.LpBoclipsFetcher(LP.config);
    return LpBoclips.LpBoclipsActions.cache.fetcher;
  },

  getSearchParams(context, additionalParams) {
    const store = context.getStore('VideoModeStore');
    const storeState = store.currentState();
    const searchParams = store.getAll();
    return $.extend(true, {}, searchParams, additionalParams, {
      page: parseInt(storeState.page, 10),
      search_count: storeState.searchResultsCount
    });
  },

  loadSearch(context, additionalParams, successCallback) {
    if (!additionalParams) {
      additionalParams = {};
    }
    return LpBoclips.LpBoclipsActions.fetcher()
      .loadSearch(LpBoclips.LpBoclipsActions.getSearchParams(context, additionalParams))
      .done(function (rawSearch) {
        if ($.trim(String(rawSearch.total)) !== '') {
          $('#js-search-heading #total_search_results').html(rawSearch.total);
        }
        if (
          typeof rawSearch.pagination !== 'undefined' &&
          $.trim(String(rawSearch.pagination)) !== ''
        ) {
          $('#search-pagination')
            .removeClass('boclips-pagination')
            .addClass('boclips-pagination');
          $('#search-pagination').removeClass('hide').html(rawSearch.pagination);
        } else {
          $('#search-pagination').removeClass('boclips-pagination');
          $('#search-pagination').removeClass('hide').addClass('hide');
        }
        if ($.trim(String(rawSearch.total_pages)) !== '') {
          $('#boclips-videos-section').removeClass('loading-boclips-videos-section');
          context.dispatch('VIDEOS_RECEIVE_SEARCH', { rawSearch });
        }
        if (typeof successCallback === 'function') {
          successCallback.call(null, rawSearch);
        }
      });
  },

  loadResourceModal(context, payload, successCallback) {
    if (!payload) {
      payload = {};
    }
    if (!successCallback) {
      successCallback = null;
    }
    return LpBoclips.LpBoclipsActions.fetcher()
      .loadResourceModal(payload)
      .done(function (rawResponse) {
        if (typeof successCallback === 'function') {
          successCallback.call(rawResponse);
        }
      });
  },

  hideResource(context, payload) {
    context.dispatch('HIDE_RESOURCE', payload);
  },

  showResource(context, payload) {
    LP.module('LpBoclips').BoclipsModal.setContext(context);
    $.extend(true, payload, { type: 'boclips_video' });
    context.dispatch('SHOW_RESOURCE', payload);
  },

  toggleMoreLess(context) {
    context.dispatch('VIDEOS_TOGGLE_VIEW_MORE');
  },

  toggleViewAll(context) {
    context.dispatch('VIDEOS_TOGGLE_VIEW_ALL');
    LP.module('Searches').applyLoaderToResultCards();
  },

  onHistoryChange(context, payload) {
    context.dispatch('VIDEOS_BACK_FORWARD_NAVIGATION', payload);
  },

  onBackForwardNavigation(context) {
    const store = context.getStore('VideoModeStore');
    store._historyNavigationTriggerSearch = false;
    const queryString = document.location.href.match(/.*?((\?|$).*)/)[1];
    if (store.canViewAll()) {
      LpBoclips.LpBoclipsActions.clearProviderTypesAndAddVideo(context, {
        query: queryString,
        noHistory: true,
        fromBackButton: true
      });
    } else {
      context.executeAction(LP.module('Searches').SearchActions.loadSearch, {
        query: queryString,
        noHistory: true,
        fromBackButton: true
      });
    }
  },

  resetView(context) {
    context.dispatch('VIDEOS_TOGGLE_RESET_VIEW');
    LP.module('Searches').applyLoaderToResultCards();
    LP.config.withInfiniteScroll = true;
    const facetStore = context.getStore('FacetStore');
    const videoLengthFacet = facetStore.get('video_length')[0];
    if (videoLengthFacet.active) {
      videoLengthFacet.active = false;
      context.dispatch('DELETE_PARAM', 'video_length');
      context.executeAction(LP.module('Searches').SearchActions.loadSearch);
    }
  },

  onReceivedFacets(context) {
    if ($('.resource-card-loader.loading').length > 0) {
      LP.module('Searches').removeLoaderFromResultCards();
    }
  },

  _toggleResourceTypePanel(context) {
    return context.executeAction(
      LP.module('Searches').SearchActions.togglePanelCollapse,
      { keys: 'type_ids' }
    );
  },

  clearProviderTypesAndAddVideo(context, additionalSearchParams) {
    const boclipsStore = context.getStore('VideoModeStore');
    if ((LP.isPhone() || LP.isMobile()) && !boclipsStore._getVideoFacet()) {
      $.when(LpBoclips.LpBoclipsActions._toggleResourceTypePanel(context)).always(
        function () {
          LpBoclips.LpBoclipsActions.clearProviderTypesAndAddVideo(context);
        }
      );
      return;
    }

    const videoResourceType = boclipsStore._getVideoFacet();

    // needed to know when i am forcing the viewAll page
    boclipsStore._viewAllForced = true;

    if (!boclipsStore.onlyVideoResourceType() && videoResourceType) {
      const param = 'type_ids';
      const videoTypeId = videoResourceType.id;

      context.dispatch('DELETE_PARAM', param);
      context.dispatch('SET_PARAM', { key: param, val: [videoTypeId], noHistory: true });
    }
    const facetStore = context.getStore('FacetStore');
    const [videoLengthFacet] = facetStore.get('video_length');
    const videoTypesFacets = facetStore.get('video_types');
    const activeVideoTypes = boclipsStore.getActiveVideoTypes();
    if (activeVideoTypes.length === 0 && videoTypesFacets[0]) {
      const videoTypesFacet = videoTypesFacets[0];
      context.dispatch('DELETE_PARAM', 'video_types');
      videoTypesFacet.hidden = false;
      videoTypesFacet.active = false;
      videoTypesFacet.onClearAll = false;
      context.dispatch('SET_PARAM', {
        key: 'video_types',
        val: videoTypesFacet.id,
        noHistory: true
      });
      context.dispatch('TOGGLE_FACET', {
        facet: videoTypesFacet,
        noHistory: true,
        fromBackButton: true
      });
    }

    context.executeAction(
      LP.module('Searches').SearchActions.loadSearch,
      additionalSearchParams
    );
  },

  updateLayoutBasedOnCollectionBuilder(context) {
    if ($('#boclips-videos-section').length === 0) {
      return;
    }
    const videoStore = context.getStore('VideoModeStore');
    const videoState = videoStore.currentState();
    LpBoclips.LpBoclipsViewAllHelper.showThreeItemsPerRow(context);
    if (videoState.viewAll) {
      LP.module('Searches').updateLayoutBasedOnCollectionBuilder(true);
    }
  }
};
LpBoclips.LpBoclipsActions = LpBoclipsActions;
